import React from 'react';
import { NavRailSubmenuItem } from '../../../components/layout/NavRailExpandableSection';
import { buildCommunityItems } from './CommunityMenuContent';

const COMMUNITY_LABELS = {
  buddies: 'Hunting buddies',
  'find-club': 'Find a club',
  'find-processor': 'Find a processor',
  'camp-essentials': 'Camp essentials',
  'suggest-store': 'Suggest a store',
};

export function CommunityNavSubmenu({
  onOpenBuddies,
  onOpenCampEssentials,
  onOpenFindClub,
  onOpenFindProcessor,
  onSuggestStore,
}) {
  const items = buildCommunityItems({
    onOpenBuddies,
    onOpenCampEssentials,
    onOpenFindClub,
    onOpenFindProcessor,
    onSuggestStore,
  });

  return items.map((item) => (
    <NavRailSubmenuItem
      key={item.id}
      icon={item.icon}
      label={COMMUNITY_LABELS[item.id] || item.title}
      tooltip={item.disabled ? `${item.title} (coming soon)` : item.title}
      disabled={item.disabled}
      onClick={() => {
        if (item.disabled || !item.onClick) return;
        item.onClick();
      }}
    />
  ));
}
